export enum PartCategory {
  COLUMN = "Column",
  BEAM = "Beam",
  BRACE = "Brace",
  CONNECTION = "Connection",
}

export enum PartType {
  C_CHANNEL = "C",
  C_CHANNEL_LIPS = "C w/ lips",
  C_CHANNEL_LIPS_RIB = "C w/ lips w/ rib",
  CLOSED_TUBE = "Closed Tube",
  STEP_BEAM = "Step Beam",
  ANGLE = "Angle",
  PIPE = "Pipe",
  PLATE = "Plate",
  BRACKET = "Bracket",
  BOLT = "Bolt",
  PIN = "Pin",
  TAB = "Tab",
}

export interface GeometricProperties {
  h: number; // Height (in) or Diameter for Pipe/Bolt/Pin
  w: number; // Width (in) or Base for Bracket
  t: number; // Thickness (in)
  l?: number; // Lip size (in) for C-channels
  hw?: number; // Hole Width (in)
  d?: number; // Step Height (in) for Step Beam
  D?: number; // Top Flange Width (in) for Step Beam
}

export interface CalculatedProperties {
  // Left Column
  Ix: number; // Full Ix (in⁴)
  Sx: number; // Full Sx (in³)
  Rx: number; // Full Rx (in)
  Iy: number; // Full Iy (in⁴)
  Syl: number; // Full Syl (in³)
  Syr: number; // Full Syr (in³)
  Ry: number; // Full Ry (in)
  grossArea: number; // Gross Area (in²)
  netArea: number; // Net Area (in²)

  // Right Column
  cCorner: number; // C Corner (in)
  J: number; // J (in⁴)
  Xo: number; // Xo (in)
  jx: number; // jx (in) - often related to torsional beta
  Ro: number; // Ro
  Beta: number; // Beta
  Cw: number; // Cw
  weight: number; // Weight (lbs/ft) or lbs/in based on spec
  Fy: number; // Yield Strength (ksi)
  Fu: number; // Ultimate Strength (ksi)

  // Connection Specific
  Se?: number; // Effective Section Modulus (in³)
  Fnv?: number; // Nominal Shear Strength (ksi)
}

export interface AnalysisResult {
  appliedMoment: number;
  allowableMoment: number;
  actualStress: number;
  allowableStress: number;
  deflection: number;
  utilization: number;
  status: 'PASS' | 'WARN' | 'FAIL';
}

export interface Part {
  id: string;
  name: string;
  manufacturer: string;
  category: PartCategory;
  type: PartType;
  material: string;
  geometry: GeometricProperties;
  properties: CalculatedProperties;
  lastEdited: string;
}

export interface Project {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  status: "Active" | "Completed" | "Archived";
  lastModified: string;
  buildingCode: string;
  seismicSs?: number;
  seismicS1?: number;
  siteClass?: string;
  soilBearing?: string;
  slabStrength?: string;
  slabThickness?: number;
}

export interface Design {
  id: string;
  name: string;
  projectId: string;
  projectName: string;
  type: "Selective" | "Pushback" | "Flow" | "Cantilever" | "Drive In/Thru";
  status: "Draft" | "Engineering Review" | "Verified";
  lastModified: string;
}
